import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { IconContext } from 'react-icons';
import { Typography } from '@mui/material';

// ================== Styled Components ==================
const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  position: relative;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #F7F7F7;
  }
`;

const AvatarCircle = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background-color: ${({ bg }) => bg || '#ccc'};
  color: #fff;
  font-weight: 600;
  font-size: ${({ size }) => size * 0.4}px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  ${({ src }) =>
    src &&
    css`
      background-color: transparent;
      background-image: url(${src});
      background-size: cover;
      background-position: center;
      color: transparent;
    `}
`;

const InnerIcon = styled.div`
  border-radius: 50%;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
`;

// Optional label outside the avatar
const Label = styled.span`
  font-size: 14px;
  color: #333;
`;


const MenuItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
`;

// ================== Avatar Component ==================
const Avatar = ({ label, src, size = 40, bg, menuItems = [], icon }) => {
  const [open, setOpen] = useState(false);

  const handleToggleMenu = () => {
    if (menuItems.length) setOpen((prev) => !prev);
  };

  return (
    <Wrapper onClick={handleToggleMenu}>
      <AvatarCircle size={size} src={src} bg={bg} title={label}>
        {/* Show initials if no src */}
        {!src && !icon && label ? label[0].toUpperCase() : null}

        {/* Show inner icon if provided */}
        {icon && (
          <InnerIcon>
            <IconContext.Provider value={{ size: `${size * 0.35}px`, color: '#000' }}>
              {icon}
            </IconContext.Provider>
          </InnerIcon>
        )}
      </AvatarCircle>

      {label && <Typography variant='body1' sx={{ color: '#666666', ml: 1 }}>{label}</Typography>}
    </Wrapper>
  );
};

export default Avatar;
